import { gql, useQuery } from '@apollo/client';

const programmaFileQueryGQL = gql`
    query GetProgrammaFile($editionName: String){
        getProgrammaFile(editionName: $editionName) {
            name
            downloadUrl
            fileSize
        }
    }
`;

export const useProgrammaFileQueryGQL = ({ editionName }) =>
    useQuery(programmaFileQueryGQL, { variables: { editionName } });
